import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface GradeCardProps {
  className?: string;
  grade: string;
}

const gradeComments: { [key: string]: string } = {
  S: "外国人雇用管理アンケートにおける「採用」「労務」「人事制度」「人材マネジメント」「働きがい」「人権」「社内合意」の７つの項目すべてにおいて、とても高い問題意識を持ち、組織の制度と運用を適切に行い、外国人材の適正雇用に責任をもって取り組まれています。",
  A: "外国人雇用管理アンケートにおける「採用」「労務」「人事制度」「人材マネジメント」「働きがい」「人権」「社内合意」の７つの項目すべてにおいて、高い問題意識を持ち、いくつか細部に改善の予知はあるものの、組織の制度と運用を適切に行い、外国人材の適正雇用に責任をもって取り組まれています。",
  B: "外国人雇用管理アンケートにおける「採用」「労務」「人事制度」「人材マネジメント」「働きがい」「人権」「社内合意」の７つの項目において、期待に応える問題意識を持ち、いくつか改善の余地はありますが、外国人材の適正雇用に責任をもって取り組まれています。",
  C: "外国人雇用管理アンケートにおける「採用」「労務」「人事制度」「人材マネジメント」「働きがい」「人権」「社内合意」の７つの項目において、ある程度の取組みができていますが、改善の余地が多くあります。問題意識をもって外国人材の適正雇用に努めましょう。",
  D: "外国人雇用管理アンケートにおける「採用」「労務」「人事制度」「人材マネジメント」「働きがい」「人権」「社内合意」の７つの項目において、十分な取組みができているとはいえず、全体として改善の余地があります。外国人材の適正雇用に向けて総点検をすることをおすすめします。",
};

function GradeCard({ className, grade }: GradeCardProps) {
  const { t } = useTranslation();
  const comment = gradeComments[grade] || t("invalid-grade");

  return (
    <div
      className={twMerge(
        className,
        "flex gap-2 rounded-b-lg border-t-2 border-cyan-600 px-4 py-3 shadow",
      )}
    >
      <div className="flex flex-col items-center gap-2 min-w-[60px]">
        <div className="text-cyan-600">{t("grade")}</div>
        <div className="text-3xl font-bold text-cool-gray-900">{grade}</div>
      </div>
      <div className="text-sm text-cool-gray-600">{comment}</div>
    </div>
  );
}

export default GradeCard;
